import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {HomePage} from './home.page';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import { DelegateHomeComponent } from './delegate-home/delegate-home.component';
import { CoachHomeComponent } from './coach-home/coach-home.component';
import {VideoChatModule} from "../video-chat/video-chat.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,

        TranslateModule.forChild(),
        RouterModule.forChild([
            {
                path: '',
                component: HomePage
            }
        ]),
        ComponentsModule,
        VideoChatModule
    ],
    declarations: [HomePage,
        DelegateHomeComponent,
        CoachHomeComponent
    ]
})
export class HomeModule {
}
